import React, { PureComponent } from 'react'
import { isNull } from 'lodash'
import { connect } from 'react-redux'
import WayPoint from 'react-waypoint'
import Spinner from '../../common/Spinner'
import NoResults from '../../common/NoResults'
import ListCard from '../../common/ListCard'
import CardItemSwapExpandable from '../Swap/CardItemSwap'

import {
  getSearchItems,
  canLoadMoreSearchItems,
  getTotalSearchItems,
  getSearchItemsLoading,
} from '../../selectors'
import {
  loadItemsSearch,
  loadMoreItemsSearch,
  unloadItemsSearch,
} from '../../actions'

const styles = {
  listItem: {
    cursor: 'pointer',
  },
}

class SearchItemList extends PureComponent {
  componentDidMount() {
    this.props.loadItemsSearch({
      cat_id: this.props.category.id,
      q: this.props.searchString,
    })
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.category !== nextProps.category ||
      this.props.searchString !== nextProps.searchString
    ) {
      this.props.unloadItemsSearch()
      this.props.loadItemsSearch({
        cat_id: nextProps.category.id,
        q: this.props.searchString,
      })
    }
  }

  componentWillUnmount() {
    this.props.unloadItemsSearch()
  }

  loadMore = () => {
    this.props.loadMoreItemsSearch({
      cat_id: this.props.category.id,
      q: this.props.searchString,
    })
  }

  render() {
    const {
      loading,
      items,
      canLoadMoreItems,
      searchString,
      onItemSelected,
    } = this.props

    return (
      <div style={{ height: '80vh' }}>
        {loading && isNull(items) && <Spinner centered />}

        {!loading &&
          !isNull(items) &&
          items.length === 0 && (
            <NoResults>
              Nessun oggetto per la ricerca{' '}
              <b>
                <i>{searchString}</i>
              </b>
            </NoResults>
          )}

        {!isNull(items) &&
          items.length > 0 && (
            <div>
              {items.map(item => (
                <div
                  key={item._id}
                  style={styles.listItem}
                  onClick={() => onItemSelected(item)}>
                  <CardItemSwapExpandable
                    editable={false}
                    item={item}
                    moneyChip={false}
                  />
                </div>
              ))}
            </div>
          )}

        {/*  Loading more spinner */}
        {loading && !isNull(items) && items.length > 0 && <Spinner centered />}

        {/* Trigger load more */}
        {!loading &&
          !isNull(items) &&
          items.length > 0 &&
          canLoadMoreItems && <WayPoint onEnter={this.loadMore} />}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  items: getSearchItems(state),
  totalItems: getTotalSearchItems(state),
  canLoadMoreItems: canLoadMoreSearchItems(state),
  loading: getSearchItemsLoading(state),
})

export default connect(mapStateToProps, {
  loadItemsSearch,
  loadMoreItemsSearch,
  unloadItemsSearch,
})(SearchItemList)



// WEBPACK FOOTER //
// ./src/common/AddItemForm/SearchItemList.js